/**
 * @generated SignedSource<<fb8f26a551ab7dff522d1b58e1b81d1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditDelegatePageRouteProposalsPaginationQuery$variables = {
  after?: string | null;
  first?: number | null;
};
export type EditDelegatePageRouteProposalsPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PastProposalsFormSectionProposalListFragment">;
};
export type EditDelegatePageRouteProposalsPaginationQuery = {
  response: EditDelegatePageRouteProposalsPaginationQuery$data;
  variables: EditDelegatePageRouteProposalsPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditDelegatePageRouteProposalsPaginationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "PastProposalsFormSectionProposalListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditDelegatePageRouteProposalsPaginationQuery",
    "selections": [
      {
        "alias": "allProposals",
        "args": (v1/*: any*/),
        "concreteType": "ProposalsConnection",
        "kind": "LinkedField",
        "name": "proposals",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProposalsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OnChainProposal",
                        "kind": "LinkedField",
                        "name": "onChainProposal",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "number",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "OnChainProposalType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SnapshotProposal",
                        "kind": "LinkedField",
                        "name": "snapshotProposal",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "SnapshotProposalType",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "allProposals",
        "args": (v1/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "PastProposalsForm_allProposals",
        "kind": "LinkedHandle",
        "name": "proposals"
      }
    ]
  },
  "params": {
    "cacheID": "991d8f8d51bc34df2eb8bfd079c0fb53",
    "id": null,
    "metadata": {},
    "name": "EditDelegatePageRouteProposalsPaginationQuery",
    "operationKind": "query",
    "text": "query EditDelegatePageRouteProposalsPaginationQuery(\n  $after: String\n  $first: Int = 10\n) {\n  ...PastProposalsFormSectionProposalListFragment_2HEEH6\n}\n\nfragment PastProposalsFormSectionProposalListFragment_2HEEH6 on Query {\n  allProposals: proposals(after: $after, first: $first) {\n    edges {\n      node {\n        __typename\n        ... on OnChainProposalType {\n          id\n          onChainProposal {\n            title\n            number\n            id\n          }\n        }\n        ... on SnapshotProposalType {\n          id\n          snapshotProposal {\n            title\n            id\n          }\n        }\n        id\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f284b25410fe7e82fe7950555989f405";

export default node;
